import { Box, Flex } from 'design-system';
import { Section } from 'layout/index';
import { LayoutProps } from 'layout/types';

export const PreLoginPageLayout = ({ sections }: LayoutProps) => (
  <Flex as='main' minH='100vh' bg='gray.50' align='center' justify='center' p={{ base: 'md', sm: 'lg' }}>
    <Box
      w='100%'
      maxW='400px'
      bg='white'
      border='1px solid'
      borderColor='gray.200'
      borderRadius='xl'
      p={{ base: '24px', sm: '40px' }}>
      <Section sections={sections} name='content' />
    </Box>
  </Flex>
);
